module.exports = __webpack_public_path__ + "img/W-as13.95695f4b.jpg";